module.exports = __webpack_public_path__ + "media/140.c3e0429f.mp3";